(() => {
  'use strict';

  const KEY = 'mxpRepairDraftV2';
  const path = location.pathname.replace(/\/$/, '');
  const FAULT = '/pages/reparation-iphone-panne';
  const QUOTE = '/pages/reparation-iphone-devis';

  if (path !== FAULT && path !== QUOTE) return;

  function readDraft() {
    try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; }
    catch (_) { return {}; }
  }

  function prime() {
    const root = document.querySelector('[data-mxp-repair]');
    if (!root) return false;

    const draft = readDraft();
    const model = String(draft.model || '').trim();
    const fault = String(draft.fault || '').trim();
    const modelField = root.querySelector('[data-field="model"]');
    const faultField = root.querySelector('[data-field="fault"]');

    if (modelField && model && modelField.value !== model) {
      modelField.value = model;
      modelField.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (path === QUOTE && faultField && fault && faultField.value !== fault) {
      faultField.value = fault;
      faultField.dispatchEvent(new Event('change', { bubbles: true }));
    }

    return !!modelField;
  }

  if (!prime()) {
    const obs = new MutationObserver(() => {
      if (prime()) obs.disconnect();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  window.addEventListener('pageshow', prime);
})();